import Paragraph from 'reports/components/Paragraph';
import React from 'react';
import { constants } from 'reports/pages/AddTemplate/constants';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const extractTitleOrSubTileOrReportNameOrDesc = (item: any): any => {
  const accessToContentKey = 'paragraph';
  return item.slug === constants.paragraphElement || item.slug?.includes(constants.paragraphElement)
    ? {
        ...item,
        order: item.order,
        component: <Paragraph paragraphComp title={item.paragraph} />,
      }
    : item.slug === constants.titleElement || item.slug?.includes(constants.titleElement)
    ? {
        ...item,
        component: <Paragraph titleComp content={item[accessToContentKey]} />,
      }
    : item.slug === constants.subTitleElement || item.slug?.includes(constants.subTitleElement)
    ? {
        ...item,
        component: (
          <Paragraph subTitleComp content={item[accessToContentKey]} />
        ),
      }
    : item?.slug === constants.reportNameElement || item.slug?.includes(constants.reportNameElement)
    ? {
        ...item,
        component: (
          <Paragraph reportNameComp content={item[accessToContentKey]} />
        ),
      }
    : false;
};
